<template>
  <div class="teamList">
    <div>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary"
              @click="showCreateTeamDialog"
              :disabled="game.state != 'created' && game.state != 'checkin'"
              >{{$t('createTeamDialog.title')}}</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-for="team in teams" v-bind:key="team.uid">
          <v-col cols="12">
            <team-widget :team="team" :game="game">
              <v-btn @click="inviteFriendsToTeam(team)">
                <v-icon left>mdi-account-multiple-plus</v-icon>
                {{ $t("common.invite-friends") }}
              </v-btn>
            </team-widget>
          </v-col>
        </v-row>
        <v-row v-if="teams && teams.length == 0">
          <v-col cols="12">
            <span>{{ $t("teamList.no-teams-yet") }}</span>
          </v-col>
        </v-row>
      </v-container>
      <friends-selector-dialog
        :visible="showInvitePlayersDialog"
        :closeAction="hideInvitePlayersDialog"
        :acceptAction="inviteFriendsDialogAccepted"
      />
      <create-team-dialog
        :game="game"
        :visible="createTeamDialogVisible"
        :closeAction="hideCreateTeamDialog"
        :successAction="onCreateTeamDialogSuccess"
      />
    </div>
  </div>
</template>

<script>
import CreateTeamDialog from "@/widgets/CreateTeamDialog";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import TeamWidget from "@/widgets/TeamWidget.vue";
import FriendsSelectorDialog from "./FriendsSelectorDialog.vue";
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";

export default {
  name: "TeamList",
  components: {
    CreateTeamDialog,
    TeamWidget,
    FriendsSelectorDialog,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      teams: undefined,
      selectedTeam: undefined,
      createTeamDialogVisible: false,
      showInvitePlayersDialog: false,
    };
  },
  computed: {},
  watch: {
    game: function (val, oldVal) {
      if (val.uid != oldVal.uid) {
        console.log("game changed", val, oldVal);
      }
    },
  },
  mounted() {
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
    this.loadTeams();
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    onRefreshData() {
      this.loadTeams();
    },
    loadTeams() {
      this.loading = true;
      this.$api
        .getGameInstanceTeams(this.game.uid)
        .then((res) => {
          this.loading = false;
          // console.log(res.data)
          this.teams = res.data.list;
        })
        .catch((error) => {
          this.loading = false;
          this.$common.onError(error);
        });
    },
    showCreateTeamDialog() {
      this.createTeamDialogVisible = true;
    },
    hideCreateTeamDialog() {
      this.createTeamDialogVisible = false;
    },
    inviteFriendsToTeam(team) {
      this.selectedTeam = team;
      this.showInvitePlayersDialog = true;
    },
    hideInvitePlayersDialog() {
      this.showInvitePlayersDialog = false;
    },
    inviteFriendsDialogAccepted(selectedFriends) {
      console.log(this.selectedTeam, selectedFriends);
      if (selectedFriends.length == 0) {
        return;
      }
      let friendUIDsToInvite = selectedFriends.map((friend) => {
        return friend.uid;
      });
      this.$api
        .inviteUsersToGameInstanceTeam(
          this.game.uid,
          this.selectedTeam.uid,
          friendUIDsToInvite
        )
        .then(() => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: this.$tc(
              "common.num-players-invited",
              selectedFriends.length,
              { num: selectedFriends.length }
            ),
            type: "success",
          });
          this.loadTeams();
        })
        .catch((error) => {
          this.loading = false;
          this.$common.onError(error);
        });
    },
    onCreateTeamDialogSuccess() {
      this.loadTeams()
    }
  },
};
</script>
